// Shuffle an array - really basic
// export default function shuffle(array) {
//   return array.sort(() => Math.random() - 0.5);
// }

export default function shuffle(array) {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
  return array
}


// WEBPACK FOOTER //
// ./src/utils/shuffle.js